import React from 'react';
import styled from 'styled-components';

import { Event } from '../../interfaces';
import { getPreImageThumbnailURL } from '../../utils';

interface Props {
  event: Event;
}

const StyledImg = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 1;
  opacity: 0;
  transition: opacity 0.1s ease-in-out;
  pointer-events: none;

  &:hover {
    opacity: 1;
  }
`;

export const PreImageThumb = (props: Props) => {
  const { event } = props;

  const imageUrl = getPreImageThumbnailURL(event);

  return <StyledImg src={imageUrl} className="pre-image-thumb" />;
};
